module.exports = __webpack_public_path__ + "media/images/slovakia-flag-round-6b86c2d2170da4c0389bc8864f56e42e.png";